import { useCallback, useMemo, useRef } from 'react';

import { Colors, Text } from '@mercator-gcp/grout';

import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import Content from 'components/widgets/Notes/Content';
import { formatNotesDate } from 'utils/date';

interface ReadOnlyNoteProps {
  targetId: number | string;
  note: string;
  updated_at: string;
  first_name?: string;
  last_name?: string;
  email: string;
}

const parentCol = {
  width: '100%',
  paddingBottom: '12px',
};
const nameAndTimeRow = { paddingBottom: '4px', gap: 'padding_8' };

const ReadOnlyNote = ({
  targetId,
  note,
  updated_at,
  first_name,
  last_name,
  email,
}: ReadOnlyNoteProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const noOp = useCallback(() => {}, []);
  const userName = useMemo(() => {
    if (first_name && last_name) {
      return `${first_name} ${last_name}`;
    }
    if (first_name) {
      return `${first_name}`;
    }

    return email;
  }, [first_name, last_name, email]);

  return (
    <FlexRow key={`readonly-note-${targetId}-${updated_at}`}>
      <FlexColumn sx={parentCol}>
        <FlexRow sx={nameAndTimeRow}>
          <Text.SmallBold align="left" color={Colors.Black900}>
            {userName}
          </Text.SmallBold>
          <Text.Small align="right" color={Colors.TextQuiet}>
            {formatNotesDate(updated_at)}
          </Text.Small>
        </FlexRow>
        <Content
          note={note}
          isEditing={false}
          setIsEditing={noOp}
          setShowButtons={noOp}
          onNoteChange={noOp}
          onNoteFocus={noOp}
          onNoteBlur={noOp}
          isOverLimit={false}
          setIsOverLimit={noOp}
          textAreaRef={textareaRef}
        />
      </FlexColumn>
    </FlexRow>
  );
};

export default ReadOnlyNote;
